module.exports = __webpack_public_path__ + "img/1543691532.c7a845cd.jpg";